// extracted by mini-css-extract-plugin
export default {"footer":"footer__MTEyN","isPostAuthNav3":"isPostAuthNav3__MDM4N","postAuthNav3PageWrapper":"postAuthNav3PageWrapper__MThiM"};